import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-moderation-document',
  templateUrl: './moderation-document.component.html',  
  styleUrls: []
})
export class ModerationDocumentComponent implements OnInit {
  registrationModerationDocument: RegistrationModerationDocumentModel;
  rejectClicked: boolean;
  isRejectDisabled: boolean;
  isApproveDisabled: boolean;
  approveClicked: boolean;
  rejForm: FormGroup = new FormGroup({});
  apprForm: FormGroup = new FormGroup({});
  verifyForm: FormGroup = new FormGroup({});
  @ViewChild('container') 'container': ElementRef;
  @ViewChild('img') 'img': ElementRef;
  isZoomed = false;
  pos = { top: 0, left: 0, x: 0, y: 0 };
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  selectedImage: string = "image1";
  safePdfUrl: SafeResourceUrl;

  constructor(private modalCtrl: ModalController, private _snackBar: MatSnackBar, private sanitizer: DomSanitizer) { }

  ngOnInit(): void { 
    console.log("In Modal >> ", this.registrationModerationDocument);

    if('PAP_VANSHAVALI,PAP_AWARD_COPY,PAP_METRO_CITY_DOCUMENT,'.indexOf(this.registrationModerationDocument.docCode) >= 0) {
      this.safePdfUrl = this.getPdfSource();
    }
    this.rejectClicked = false;
    this.isRejectDisabled = false;
    this.rejForm = new FormGroup({
      rejectReason: new FormControl(null, Validators.required)
    });
    this.apprForm = new FormGroup({
      annualIncome: new FormControl(null, [Validators.required, Validators.min(0)])
    });
    this.verifyForm = new FormGroup({
      isDocReadable: new FormControl(null, [Validators.required]),
    });
  }

  onAction(action: string) {
    if(action === 'reject') {
      this.rejectClicked = true;
    }
    else if(action === 'approve') {
      if('Income Certificate,Income Certificate (Self),Income Certificate (Spouse),ITR (Self),ITR (Spouse),Gazetted Officers'
      .indexOf(this.registrationModerationDocument.documentCode) >=0) {
        this.approveClicked = true;
      }
      else {
        return this.modalCtrl.dismiss(null, action);
      }
    }
    else {
      return this.modalCtrl.dismiss(null, action);
    }
  }

  onSubmitReject() {
    console.log('reject submit clicked');
    if (this.rejForm.valid) {
      return this.modalCtrl.dismiss(this.rejForm.value.rejectReason, 'reject');
    }
    else {
      this._snackBar.open("Please enter Remarks for Rejection", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isRejectDisabled = false;
    }
  }

  onSubmitApproved() {
    console.log('approve submit clicked');
    if (this.apprForm.valid) {
      return this.modalCtrl.dismiss(this.apprForm.value.annualIncome, 'approve');
    }
    else {
      this._snackBar.open("Please enter Income Certificate Income", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isApproveDisabled = false;
    }
  }

  onCancel() {
    this.rejectClicked = false;
    this.approveClicked = false;
  }

  onClickImage(e) {
    console.log(e.clientY, e.clientX);
    this.isZoomed = !this.isZoomed;
    if (this.isZoomed) {
      this.container.nativeElement.style.overflow = 'hidden';
      this.img.nativeElement.style.width = '200%';
      this.img.nativeElement.style.cursor = 'zoom-out';
      this.img.nativeElement.style.cursor = 'zoom-out';
      this.img.nativeElement.style.left = `-${e.clientX}`;
      this.img.nativeElement.style.top = `-${e.clientY}`;
    } else {
      this.container.nativeElement.style.overflow = 'hidden';
      this.img.nativeElement.style.class = '100%';
      this.img.nativeElement.style.cursor = 'zoom-in';
    }
  }
  onMouseDownImage(e) {
    this.pos = {
      // The current scroll
      left: this.container.nativeElement.scrollLeft,
      top: this.container.nativeElement.scrollTop,
      // Get the current mouse position
      x: e.clientX,
      y: e.clientY,
    };
  }

  mouseMoveHandlerImage(e) {
    // How far the mouse has been moved
    const dx = (e.clientX - this.pos.x) * 2;
    const dy = (e.clientY - this.pos.y) * 3;

    // Scroll the element
    this.container.nativeElement.scrollTop = this.pos.top - dy;
    this.container.nativeElement.scrollLeft = this.pos.left - dx;
  }

  onClickIsDocReadable(data: string) {
    if(data === 'Y') {
      if('Domicile,Income Certificate,Income Certificate (Self),Income Certificate (Spouse),Caste Certificate,Caste Validity'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.addControl('hasBarcode', new FormControl(null, [Validators.required]));
      }
      else if('ITR (Self),ITR (Spouse)'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.addControl('isAssessmentYearCorrect', new FormControl(null, [Validators.required]));
      }
      else if('Gazetted Officers'.indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.addControl('originalDesignation', new FormControl(null, [Validators.required]));
        this.verifyForm.addControl('curOrganizationName', new FormControl(null, [Validators.required]));
        this.verifyForm.addControl('designation', new FormControl(null, [Validators.required]));
      }
    }
    else {
      if('Domicile,Income Certificate,Income Certificate (Self),Income Certificate (Spouse),Caste Certificate,Caste Validity'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.removeControl('hasBarcode');
      }
      else if('ITR (Self),ITR (Spouse)'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.removeControl('isAssessmentYearCorrect');
        this.verifyForm.removeControl('isIncomeCorrect');
      }
      else if('Gazetted Officers'.indexOf(this.registrationModerationDocument.documentCode) >= 0) {
          this.verifyForm.removeControl('originalDesignation');
          this.verifyForm.removeControl('curOrganizationName');
          this.verifyForm.removeControl('designation');
        }
    }
  }

  onClickHasBarcode(data: string) {
    if('Domicile,Income Certificate,Income Certificate (Self),Income Certificate (Spouse)'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
      if(data === 'Y') {
        this.verifyForm.addControl('afterPeriod', new FormControl(null, [Validators.required]));
      }
      else {
        this.verifyForm.removeControl('afterPeriod');
      }
    }
  }

  onClickIsAssessmentYearCorrect(data: string) {
    if(data === 'Y') {
      this.verifyForm.addControl('isIncomeCorrect', new FormControl(null, [Validators.required]));
    }
    else {
      this.verifyForm.removeControl('isIncomeCorrect');
    }
  }

  onClickAfterPeriod(data: string) {
    if(data === 'Y') {
      this.verifyForm.addControl('barcode', new FormControl(null, [Validators.required]));
      this.verifyForm.addControl('reEnterBarcode', new FormControl(null, [Validators.required]));

      if('Income Certificate,Income Certificate (Self),Income Certificate (Spouse)'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.addControl('annualIncome', new FormControl(null, [Validators.required, 
        Validators.min(0)]));
      }

    }
    else {
      this.verifyForm.removeControl('barcode');
      this.verifyForm.removeControl('reEnterBarcode');

      if('Income Certificate,Income Certificate (Self),Income Certificate (Spouse)'
      .indexOf(this.registrationModerationDocument.documentCode) >= 0) {
        this.verifyForm.removeControl('annualIncome');
      }
    }
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      if('DOMICILE,INCOME_CERTIFICATE,INCOME_CERTIFICATE_SELF,INCOME_CERTIFICATE_SPOUSE'
      .indexOf(this.registrationModerationDocument.docCode) >= 0) {
        if(this.verifyForm.value?.barcode === this.verifyForm.value?.reEnterBarcode) {
          return this.modalCtrl.dismiss({
            isDocReadable: this.verifyForm.value?.isDocReadable,
            hasBarcode: this.verifyForm.value?.hasBarcode,
            afterPeriod: this.verifyForm.value?.afterPeriod,
            barcode: this.verifyForm.value?.barcode,
            reEnterBarcode: this.verifyForm.value?.reEnterBarcode,
            annualIncome: this.verifyForm.value?.annualIncome,
            rwsSelfInc: this.registrationModerationDocument.rwsSelfInc !=null ? this.registrationModerationDocument.rwsSelfInc : null,
            rwsSpouseInc: this.registrationModerationDocument.rwsSpouseInc !=null ? this.registrationModerationDocument.rwsSpouseInc : null,
            rwsFinancialYear: this.registrationModerationDocument.rwsFinancialYear !=null ? this.registrationModerationDocument.rwsFinancialYear : null,
          }, 'verify');
        }
        else {
          this.verifyErrorMessage = "Barcode and Re-enter Barcode should match.";
          this.isVerifyDisabled = false;
        }
      }
      else if('ITR_SELF,ITR_SPOUSE'
      .indexOf(this.registrationModerationDocument.docCode) >= 0) {
        return this.modalCtrl.dismiss({
          isDocReadable: this.verifyForm.value?.isDocReadable,
          isAssessmentYearCorrect: this.verifyForm.value?.isAssessmentYearCorrect,
          isIncomeCorrect: this.verifyForm.value?.isIncomeCorrect,
        }, 'verify');
      }
      else if('GAZETTED_OFFICERS'.indexOf(this.registrationModerationDocument.docCode) >= 0) {
        return this.modalCtrl.dismiss({
          isDocReadable: this.verifyForm.value?.isDocReadable,
          originalDesignation: this.verifyForm.value?.originalDesignation,
          curOrganizationName: this.verifyForm.value?.curOrganizationName,
          designation: this.verifyForm.value?.designation,
        }, 'verify');
      }
      else if('PAP_VANSHAVALI,PAP_AWARD_COPY,PAP_METRO_CITY_DOCUMENT,MATHADI_KAMGAR,RELIGIOUS_MINORITY'.indexOf(this.registrationModerationDocument.docCode) >= 0) {
        return this.modalCtrl.dismiss({
          isDocReadable: this.verifyForm.value?.isDocReadable,
        }, 'verify');
      }
      else {
        return this.modalCtrl.dismiss({
          isDocReadable: this.verifyForm.value?.isDocReadable,
          hasBarcode: this.verifyForm.value?.hasBarcode,
          afterPeriod: this.verifyForm.value?.afterPeriod,
        }, 'verify');
      }
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }

  getImageSource() {
    if (this.selectedImage === "image1") {
      return this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64, ' + this.registrationModerationDocument.document);
    } else if (this.selectedImage === "image2") {
      return this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64, ' + this.registrationModerationDocument.cvDocument);
    } else if (this.selectedImage === "image3") {
      return this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64, ' + this.registrationModerationDocument.document1);
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64, ' + this.registrationModerationDocument.document);
    }
  }

  getPdfSource() {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64, ' + this.registrationModerationDocument.document);
  }

  
}
